/**
 * Generic Relationship Map fit policy helpers (no domain-specific graph logic).
 */

export const CHAT_GRAPH_FIT_OPTIONS = {
  padding: 0.2,
  maxZoom: 1.2,
  minZoom: 0.2,
};

/**
 * External fit bumps (e.g. modal afterOpenChange) are truthy counters.
 * Embedded graphs do not rely on a hardcoded numeric trigger.
 */
export function shouldFitOnExternalTrigger(fitTrigger) {
  return Boolean(fitTrigger);
}

/**
 * Fit when a previously hidden container becomes visible again
 * (e.g. Ant Design Collapse reopen). Do not fit while already visible.
 */
export function shouldFitOnVisibilityChange(wasIntersecting, isIntersecting) {
  return Boolean(isIntersecting) && !wasIntersecting;
}

/**
 * Schedule fitView after layout/paint so React Flow can measure nodes.
 * Returns a cancel function.
 */
export function scheduleMeasuredFitView(fitView, options = CHAT_GRAPH_FIT_OPTIONS) {
  if (typeof fitView !== 'function') {
    return () => {};
  }
  let cancelled = false;
  let raf2 = 0;
  const raf1 = requestAnimationFrame(() => {
    raf2 = requestAnimationFrame(() => {
      if (cancelled) return;
      try {
        fitView(options);
      } catch {
        /* ignore measurement races */
      }
    });
  });
  return () => {
    cancelled = true;
    cancelAnimationFrame(raf1);
    if (raf2) cancelAnimationFrame(raf2);
  };
}
